import { render, staticRenderFns } from "./exhibition-card-vip.vue?vue&type=template&id=bbb7671a&scoped=true&"
import script from "./exhibition-card-vip.vue?vue&type=script&lang=js&"
export * from "./exhibition-card-vip.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-card-vip.vue?vue&type=style&index=0&id=bbb7671a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb7671a",
  null
  
)

export default component.exports